import React from 'react';
import Modal from 'react-modal';

import classnames from 'classnames';
import { CSSProperties } from 'react';

import "./../../../scss/full-screen-modal.scss";

export enum Theme {
    standard,
    dark,
    gold,
    green,
    red
}

export interface IProps {
    isOpen: boolean;
    
    onClose?: Function;
    onBack?: Function;
    
    contentClass?: string;
    mainContainerClassName?: string;
    title?: string;
    subtitle?: string;

    theme?: Theme

    isAutoOverflow?: boolean;

    subtitleStyle?: CSSProperties;

    hasBackButton?:boolean;

    isContentVerticalTop?: boolean;
    initialOverlayTop?: string;
    dontGoFullWidth?: boolean;
    hasNoPadding?: boolean;
    noWidthLimitation?: boolean;
    contentTopOffset?: number;
    additionalModalHeaderClass?: string;
    isPositionStatic?: boolean;

    parentElement?: HTMLElement;

    actionMessageHTML?: string;
    cancelationMessageHTML?: string;

    secondayActionMessageHTML?: string;

    onActionClicked?: () => void;
    onCancelationClicked?: () => void;

    actionButtonAdditionalClass?: string;
    secondaryActionButtonAdditionalClass?: string;

    onSecondaryActionClicked?: () => void;

    modalContentStyle?: CSSProperties;
    modalOverlayStyle?: CSSProperties;
    contentStyle?: CSSProperties;
    contentContainerStyle?: CSSProperties;
    
    overlayClass?: string;
    disableBackgroundClickClose?: boolean;

    children?: React.ReactNode;
}

const modalOverlayStyle: CSSProperties = {
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    zIndex: 1008,
    top: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position:"fixed"
};

const modalOverlayTopStyle: CSSProperties = {
    alignItems: "flex-start"
}

const modalContentStyle: CSSProperties = {
    backgroundColor: "rgb(255, 255, 255)",
    display: "fixed",
    position: "relative",
    top:"unset",
    left: "unset",
    right: "unset",
    bottom: "unset",
    border: "unset",
    borderRadius: "unset",
    width: "100%",
    color: "#3C3C3C",
    overflow: "visible",
    padding: "20px 40px"
};

const contentContainerStyle: CSSProperties = {
    maxWidth: "600px", 
    margin: "0 auto",
    padding: "0",
};

const contentStyle: CSSProperties = {
    maxHeight: "90vh",
    overflow: "auto",
    maxWidth: "85vw"
};

export default class FullScreenModal extends React.Component<IProps, {}> {
    public render(){
        let _modalContentStyle = Object.assign({}, modalContentStyle, this.props.modalContentStyle || {});
        let _modalOverlayStyle = Object.assign({}, modalOverlayStyle, this.props.modalOverlayStyle || {});
        let _contentStyle = Object.assign({}, contentStyle, this.props.contentStyle || {});
        let _contentContainerStyle = Object.assign({}, contentContainerStyle, this.props.contentContainerStyle || {});

        if(this.props.isContentVerticalTop){
            _modalOverlayStyle = Object.assign({}, _modalOverlayStyle, modalOverlayTopStyle);
        }

        if(this.props.isPositionStatic){
            _modalOverlayStyle = Object.assign({}, _modalOverlayStyle, {
                position: "static"
            });
        }

        if(this.props.dontGoFullWidth){
            _modalContentStyle = Object.assign({}, _modalContentStyle, {
                width: "auto"
            });
        }

        if(this.props.hasNoPadding){
            _modalContentStyle = Object.assign({}, _modalContentStyle, {
                padding: "0"
            });
        }

        if(this.props.noWidthLimitation){
            _contentStyle = Object.assign({}, _contentStyle, {
                maxWidth: "auto"
            });

            _contentContainerStyle = Object.assign({}, _contentContainerStyle, {
                maxWidth: "auto"
            });
        }
        
        if(this.props.theme == Theme.dark){
            _modalContentStyle = Object.assign({}, _modalContentStyle, {
                backgroundColor: "rgb(51, 51,51)"
            });
        }
        else if(this.props.theme == Theme.gold){
            _modalContentStyle = Object.assign({}, _modalContentStyle, {
                backgroundColor: "rgb(254, 203, 47)"
            });
        }
        else if(this.props.theme == Theme.green){
            _modalContentStyle = Object.assign({}, _modalContentStyle, {
                backgroundColor: "rgb(57, 121, 38)"
            });
        }
        else if(this.props.theme == Theme.red){
            _modalContentStyle = Object.assign({}, _modalContentStyle, {
                backgroundColor: "rgb(195, 41, 28)"
            });
        }

        if(this.props.contentTopOffset){
            _modalContentStyle = Object.assign({}, _modalContentStyle, {
                top: this.props.contentTopOffset
            });
        }

        if(this.props.initialOverlayTop){
            _modalOverlayStyle.top = this.props.initialOverlayTop;
            _contentStyle.maxHeight = `calc(${contentStyle.maxHeight} - ${this.props.initialOverlayTop})`;
        }

        const themeClassNameObj = {
            "dark-theme": this.props.theme == Theme.dark, 
            "gold-theme": this.props.theme == Theme.gold, 
            "green-theme": this.props.theme == Theme.green,
            "red-theme": this.props.theme == Theme.red
        };

        if(this.props.isAutoOverflow){
            _modalOverlayStyle = {..._modalOverlayStyle, overflow: "auto"}
        }

        if(this.props.parentElement && this.props.parentElement != document.body){
            return <div className={classnames("ReactModal__Overlay", this.props.overlayClass)} style={_modalOverlayStyle}>
                    <div className={this.props.contentClass} style={_modalContentStyle}>
                        { this.generateModalContent(themeClassNameObj, _contentContainerStyle, _contentStyle)} 
                    </div>
                   </div>
        }
        else {
            return <Modal isOpen={this.props.isOpen}
                      appElement={document.body}
                      style={{ 
                          overlay: _modalOverlayStyle, 
                          content: _modalContentStyle 
                      }}
                      parentSelector={() => document.body}
                      onRequestClose={() => {
                          if(this.props.disableBackgroundClickClose) { return; }
                          
                          if(this.props.onClose != null){
                            if(this.props.onClose instanceof Function){
                                this.props.onClose();
                            }  
                            else {
                                console.error && console.error("onClose is not a function", this.props.onClose, this.props.mainContainerClassName);
                            }
                          };
                        }}>
                     { this.generateModalContent(themeClassNameObj, _contentContainerStyle, _contentStyle)} 
               </Modal>
        }
    }

    private generateModalContent(themeClassNameObj, _contentContainerStyle, _contentStyle){
        return <>
                <div className={classnames("modal-header", themeClassNameObj, this.props.additionalModalHeaderClass)}>
                    <div className="modal-back-button-container">{ this.props.hasBackButton ? <div className="modal-header-button" onTouchStart = {e => this.props.onBack && this.props.onBack()} onClick={e => this.props.onBack && this.props.onBack()}><i className="fa fw fa-chevron-left"/></div> : <i className="fa fw fa-chevron-left" style={{opacity: 0}}/>}</div>
                    <div className="modal-title-container">
                        { this.props.title && <h3 dangerouslySetInnerHTML={{__html:this.props.title}}></h3>}
                        { this.props.subtitle && <span style={this.props.subtitleStyle}>{this.props.subtitle}</span>}
                    </div>
                    <div onTouchStart={e => this.props.onClose && this.props.onClose()} onClick={e => this.props.onClose && this.props.onClose()} className={classnames("modal-close-button-container", {"no-padding": this.props.hasNoPadding})}>
                        <div className="modal-header-button">
                            <svg width="16" height="16" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.29979 0.525634C8.059 0.284844 7.67003 0.284844 7.42924 0.525634L4.41011 3.53859L1.39098 0.519459C1.15019 0.27867 0.761225 0.27867 0.520436 0.519459C0.279646 0.760249 0.279646 1.14922 0.520436 1.39001L3.53957 4.40914L0.520436 7.42827C0.279646 7.66905 0.279646 8.05802 0.520436 8.29881C0.761225 8.5396 1.15019 8.5396 1.39098 8.29881L4.41011 5.27968L7.42924 8.29881C7.67003 8.5396 8.059 8.5396 8.29979 8.29881C8.54058 8.05802 8.54058 7.66905 8.29979 7.42827L5.28066 4.40914L8.29979 1.39001C8.5344 1.15539 8.5344 0.760249 8.29979 0.525634Z" fill="currentColor"/>
                            </svg>
                        </div>
                    </div>
                </div>  
                
                <div className={classnames(this.props.mainContainerClassName, themeClassNameObj)} style={_contentContainerStyle}>
                    <div style={_contentStyle} className="modal-content-container">
                        { this.props.children }
                        <div>
                        { this.props.actionMessageHTML && <span className={classnames("tokens-button action-button", this.props.actionButtonAdditionalClass)} onClick={this.props.onActionClicked} dangerouslySetInnerHTML={{__html: this.props.actionMessageHTML}}></span> }
                        { this.props.secondayActionMessageHTML && <span className={classnames("tokens-button action-button", this.props.secondaryActionButtonAdditionalClass)} onClick={this.props.onSecondaryActionClicked} dangerouslySetInnerHTML={{__html: this.props.secondayActionMessageHTML}}></span> }
                        </div>
                        
                        { this.props.cancelationMessageHTML && <span className="tokens-button cancel-button" onClick={this.props.onCancelationClicked} dangerouslySetInnerHTML={{__html: this.props.cancelationMessageHTML}}></span> }
                    </div>
                </div>
            </>
    }
}